import "./plugins/alerts";
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./catalog/routes.js";
import store from "./catalog/store";
import "owl.carousel";
import "owl.carousel2.thumbs";

const slugs = SLUGS;
const catalog = slugs.catalog;

$(document).ready(function ($) {
  let locale = "",
    doc_lang = document.documentElement.lang;

  if (doc_lang !== "nl") locale = "/" + doc_lang;

  const router = new VueRouter({
    mode: "history",
    base: locale + "/" + catalog,
    routes: routes,
  });

  new Vue({
    el: "#catalog-content",
    router,
    store,
  });

  router.afterEach((to, from) => {
    $.ajax({
      method: "GET",
      data: {
        url: window.location.origin + locale + "/" + catalog + to.fullPath,
        locale: document.querySelector("html").lang,
      },
      url: window.location.origin + "/updateTranslations",
      success(response) {
        $(".lang-menu.header__lang-menu").html(response);
        let button_html =
          document.querySelector("html").lang.toUpperCase() +
          " " +
          '<i class="fas fa-angle-down"></i>';
        $(".lang-menu__button").html(button_html);
      },
    });
  });

  let catalog__heading = $(".catalog__heading");

  //resize event for dynamic h1
  catalog__heading.resize(function () {
    let catalog__heading = $(".catalog__heading"),
      main = $(".catalog .catalog-sidebar > .main"),
      search = $(".catalog .search"),
      search_form_bottom = $(".search-form__bottom"),
      header__catalog = $(".header__catalog"),
      height;

    height = search_form_bottom.innerHeight() + catalog__heading.innerHeight();

    try {
      main.css({
        height: "calc(100% - " + height + "px)",
      });

      search.css({
        height: "calc(100% - " + header__catalog.innerHeight() + "px)",
      });
    } catch (e) {
      console.log(e);
    }
  });

  catalog__heading.trigger("resize");
});

$(window).resize(function () {
  (() => {
    try {
      if (window.innerWidth < 400) {
        $("html").css({
          "font-size": "12px",
        });
        return;
      }

      $("html").css({
        "font-size": "",
      });
    } catch (e) {
      console.log(e);
    }
  })();
});
